module.exports = __webpack_public_path__ + "img/welcome.d776ab04.png";